import { DSSpacer, DSText } from '@zoe/ds-web'
import React from 'react'
import { BentoGalleryGridRecord } from 'types'

import { FragmentComponent } from '@/types/graphql'

import { DSGrid, DSGridBlock } from '@/components/ds/Grid/Grid'

import { BentoGalleryGrid } from '../DesignSystem/BentoGalleryGrid'
import { processTypographyMarkdown } from '../DesignSystem/Typography'

export type HeroWithGalleryRecord = {
  __typename: 'HeroWithGalleryRecord'
  id: string
  eyebrow?: string
  title: string
  subtitle?: string
  gallery: BentoGalleryGridRecord
  dataTestId?: string
}

const fragment = `
  fragment HeroWithGalleryBlockFragment on HeroWithGalleryRecord {
    __typename
    id
    eyebrow
    title
    subtitle
    gallery {
      ...BentoGalleryGridFragment
    }
    dataTestId
  }
  ${BentoGalleryGrid.fragment}
`

export const HeroWithGalleryBlock: FragmentComponent<{}, HeroWithGalleryRecord> = ({ record }) => {
  return (
    <DSGrid data-testid={record?.dataTestId}>
      <DSGridBlock
        breakConfig={{
          s: { colSpan: 2 },
          m: { colSpan: 3 },
          l: { colSpan: 7 },
          xl: { colSpan: 7 },
        }}
      >
        <BentoGalleryGrid record={record.gallery} />
      </DSGridBlock>
      <DSGridBlock
        padded
        breakConfig={{
          s: { colSpan: 2 },
          m: { colSpan: 3 },
          l: { colSpan: 5 },
          xl: { colSpan: 5 },
        }}
      >
        {record.eyebrow && (
          <>
            <DSText as="h5" variant="fluid-eyebrow-100" weight="semiBold" align="left">
              {record.eyebrow}
            </DSText>
            <DSSpacer direction="vertical" size={12} />
          </>
        )}
        <DSSpacer direction="vertical" size={16} breakAt={{ m: 8 }} />
        {record.title && (
          <>
            <DSText as="h1" variant="fluid-heading-900alt" align="left" weight="semiBold">
              {processTypographyMarkdown({
                content: record.title,
                variant: 'fluid-heading-900alt',
                weight: 'semiBold',
              })}
            </DSText>
            <DSSpacer direction="vertical" size={24} breakAt={{ m: 8 }} />
          </>
        )}
        <DSSpacer direction="vertical" size={24} breakAt={{ m: 8 }} />
        {record.subtitle && (
          <DSText as="h2" variant="fluid-paragraph-400" align="left" weight="light">
            {processTypographyMarkdown({ content: record.subtitle, variant: 'fluid-paragraph-400' })}
          </DSText>
        )}
      </DSGridBlock>
    </DSGrid>
  )
}

HeroWithGalleryBlock.fragment = fragment
HeroWithGalleryBlock.recordName = 'HeroWithGalleryRecord'
